import actions from "./actions";
import { all, takeEvery, put, call } from "redux-saga/effects";
import { getDataFromBOU, postData } from "../../Helpers/ApiMethodHelper";
import { axiosPrivateForamData } from "../../Helpers/axios";
const baseURL = process.env.REACT_APP_RECON_API_BASE_URL

function* getReconDataResponse({ payload: { cycleNo, startDate, endDate ,  fileType } }) {
  // console.log (startDate, endDate , "startDate, endDate");
  try {
    const response = yield call(
      getDataFromBOU,
      // `${baseURL}file-fetch?cycleNo=${cycleNo}&date=${date}&fileType=${fileType}`
      `${baseURL}/bill-payments/export?startDate=${startDate}&endDate=${endDate}&fileType=${fileType}`

    );
    if (response.status === 201 || response.status === 200) {
      yield put(actions.getReconDataSuccess(response?.data));
    } else {
      yield put(actions.getReconDataFailure(response?.message));
    }
  } catch (error) {
    yield put(actions.getReconDataFailure(error?.response?.data || error));
  }
}

function* getGCPDataResponse({ payload: { startDate, endDate } }) {
  try {
    const response = yield call(
      getDataFromBOU,
      `${baseURL}/bill-payments/FetchUrl?startDate=${startDate}&endDate=${endDate}`
    );

    if (response.status === 201 || response.status === 200) {
      yield put(actions.getGCPDataSuccess(response?.data));
    } else {
      yield put(actions.getGCPDataFailure(response?.message));
    }
  } catch (error) {
    yield put(actions.getGCPDataFailure(error?.response?.data || error));
  }
}

function* uploadReconData(payload) {
  //console.log(payload?.payload, "payload");
  const { file } = payload?.payload;
  try {
    const response = yield call(axiosPrivateForamData.post, `/bill-payments/upload-data`, file);

    if (response.status === 201 || response.status === 200) {
      yield put(actions.UploadFileSuccess(response?.data));
    } else {
      yield put(actions.UploadFileFailure(response?.message));
    }
  } catch (error) {
    yield put(actions.UploadFileFailure(error?.response?.data || error))
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.FETCH_FILE, getReconDataResponse)]);
  yield all([takeEvery(actions.UPLOAD_FILE, uploadReconData)]);
  yield all([takeEvery(actions.FETCH_GCP, getGCPDataResponse)]);
}
